module.exports = "/_next/static/images/noodle_stand_top-ca0dc4c2e8af4af3ed66a250f2225001.jpg";